import { createClient } from './client'
import type { Client } from './client'

export interface UnauthenticatedApi extends Client {
  new (baseUrl: string): Client
}

export class UnauthenticatedApi implements Client {
  constructor(baseUrl: string) {
    // we're abusing the `UnauthenticatedApi` interface overload with this type/class mechanics here
    // so that we can return an instance of `UnauthenticatedApi` from the constructor
    // to satisfy types in UnauthenticatedApi functions and enforce an instance that has the url set,
    // but really all we want is to return a wretch object that's chainable for the consumers
    // to create their requests
    return createClient(baseUrl) as UnauthenticatedApi
  }
}

export type UnauthenticatedApiRequest<T = unknown> = (
  api: UnauthenticatedApi,
  // For generic purposes this needs to be `any` because we don't know the shape of args ahead of time
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => (arg0: any) => Promise<T>
